(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/validate-voucher.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/validate-voucher.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup;
const TextInput = svs.ui.reactFormInputs.TextInput;
const Button = svs.ui.ReactButton;
const _svs$ticket_partner$m = svs.ticket_partner.myOrders.constants.TEXTS.VALIDATE_VOUCHER.VOUCHER_CODE,
  LABEL = _svs$ticket_partner$m.LABEL,
  NAME = _svs$ticket_partner$m.NAME,
  MAX = _svs$ticket_partner$m.MAX,
  MIN = _svs$ticket_partner$m.MIN,
  MAX_ERROR_MESSAGE = _svs$ticket_partner$m.MAX_ERROR_MESSAGE,
  MIN_ERROR_MESSAGE = _svs$ticket_partner$m.MIN_ERROR_MESSAGE,
  REQUIRED_ERROR_MESSAGE = _svs$ticket_partner$m.REQUIRED_ERROR_MESSAGE;
const _svs$ticket_partner$m2 = svs.ticket_partner.myOrders.constants.TEXTS.VALIDATE_VOUCHER,
  BUTTON_LABEL = _svs$ticket_partner$m2.BUTTON_LABEL,
  HEADER = _svs$ticket_partner$m2.HEADER;
const _svs$ticket_partner$m3 = svs.ticket_partner.myOrders.utils,
  validateCode = _svs$ticket_partner$m3.validateCode,
  mapValidateCodeError = _svs$ticket_partner$m3.mapValidateCodeError,
  mapVoucherStatus = _svs$ticket_partner$m3.mapVoucherStatus;
const _svs$ticket_partner$u = svs.ticket_partner.utils,
  showErrorDialog = _svs$ticket_partner$u.showErrorDialog,
  productMapper = _svs$ticket_partner$u.productMapper;
const ValidateVoucher = () => {
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    voucherCode = _useState2[0],
    setVoucherCode = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    voucherData = _useState4[0],
    setVoucherData = _useState4[1];
  const handleSubmit = async (e, formData) => {
    e.preventDefault();
    if (_.values(formData).some(_ref => {
      let isValid = _ref.isValid;
      return !isValid;
    })) {
      return;
    }
    svs.ui.loader.show();
    try {
      const data = await validateCode(voucherCode);
      setVoucherData(data.response);
    } catch (e) {
      setVoucherData(null);
      const errorMessage = mapValidateCodeError(e);
      showErrorDialog(errorMessage);
    }
    svs.ui.loader.hide();
  };
  return React.createElement("div", {
    className: "u-flex u-flex-justify-content-center"
  }, React.createElement("div", {
    style: {
      maxWidth: '600px'
    }
  }, React.createElement("h2", {
    className: ""
  }, HEADER), React.createElement(Form, {
    onSubmit: handleSubmit
  }, React.createElement(GridRow, {
    className: ""
  }, React.createElement(GridCol, {
    className: ""
  }, React.createElement(TextInput, {
    errorMessageMax: MAX_ERROR_MESSAGE,
    errorMessageMin: MIN_ERROR_MESSAGE,
    errorMessageRequired: REQUIRED_ERROR_MESSAGE,
    id: NAME,
    isLessSpace: true,
    isRequired: true,
    label: LABEL,
    max: MAX,
    min: MIN,
    name: NAME,
    onChange: e => {
      setVoucherCode(e.target.value);
    },
    value: voucherCode
  }))), voucherData && React.createElement(GridRow, {
    className: "padding-top-2"
  }, React.createElement(GridCol, {
    am: 8,
    className: "",
    sm: 12
  }, React.createElement("div", null, React.createElement("b", null, "Kod: "), React.createElement("span", null, voucherData.voucherInfo[0].voucherId)), React.createElement("div", null, React.createElement("b", null, "Typ: "), React.createElement("span", null, productMapper(voucherData === null || voucherData === void 0 ? void 0 : voucherData.packageId))), React.createElement("div", null, React.createElement("b", null, "Skapad: "), React.createElement("span", null, svs.utils.date.SimpleDate(new Date(voucherData.creationTime)))), React.createElement("div", null, React.createElement("b", null, "Giltig till: "), React.createElement("span", null, svs.utils.date.SimpleDate(new Date(voucherData.lastValidDate)))), React.createElement("div", null, React.createElement("b", null, "Status: "), React.createElement("span", null, mapVoucherStatus(voucherData))))), React.createElement(GridCol, null, React.createElement(GridRow, null, React.createElement(ControlGroup, {
    className: "",
    v2: true
  }, React.createElement(Button, {
    className: "u-flex u-flex-align-items-center button-row-button-center u-flex-justify-content-center",
    transparent: true,
    type: "submit"
  }, BUTTON_LABEL)))))));
};
svs.ticket_partner.myOrders.components.ValidateVoucher = ValidateVoucher;

 })(window);